// @ts-strict-ignore
import { FriendInfoVO } from '@project/components/permissions/friend-info.vo';

export class FriendSharedInfo {
  private _id: number;
  private _friendInfo: FriendInfoVO = null;
  private _isReadable: boolean = false;
  private _isEditable: boolean = false;
  private _updateChildrenAvailable: boolean = false;
  private _creationDate: Date;

  public get id(): number {
    return this._id;
  }

  public set id(id: number) {
    this._id = id;
  }

  public get userId(): number {
    return !this._friendInfo ? NaN : this._friendInfo.id;
 }

  public get username(): string {
    return !this._friendInfo ? null : this._friendInfo.username;
  }

  public set username(name: string) {
    if (this._friendInfo) {
      this._friendInfo.username = name;
    }
  }

  public get isReadable(): boolean {
    return this._isReadable;
  }

  public set isReadable(value: boolean) {
    if (this._isReadable === value) {
      return;
    }
    this._isReadable = value;
    if (!this._isReadable) {
      this.isEditable = false;
    }
  }

  public get isEditable(): boolean {
    return this._isEditable;
  }

  public set isEditable(value: boolean) {
    if (this._isEditable === value) {
      return;
    }
    this._isEditable = value;
    if (this._isEditable) {
      this.isReadable = true;
    }
  }

  public get updateChildrenAvailable(): boolean {
    return this._updateChildrenAvailable;
  }

  public set updateChildrenAvailable(value: boolean) {
    this._updateChildrenAvailable = value;
  }

  public get creationDate(): Date {
    return this._creationDate;
  }

  public set creationDate(creationDate: Date) {
    this._creationDate = creationDate;
 }

  constructor(friendInfo: FriendInfoVO = null) {
    this._friendInfo = friendInfo;
  }

  public clone(): FriendSharedInfo {
    const clonedData: FriendSharedInfo = new FriendSharedInfo(this._friendInfo ? this._friendInfo.clone() : null);
    clonedData.id = this._id;
    clonedData.isReadable = this._isReadable;
    clonedData.isEditable = this._isEditable;
    clonedData.updateChildrenAvailable = this._updateChildrenAvailable;
    clonedData.creationDate = this._creationDate;
    return clonedData;
  }
}
